// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"4":"36dd77aa","326":"c30d159e"}[chunkId] + ".js";
};